import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { SharedServices } from '../../../../../../services/shared.services'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import * as $ from 'jquery'
import { StateServices } from '../../../../../../services/state.services'


@Component({
    selector: 'app-modal-client-detail-top-registraion-tooth',
    templateUrl: './modal-client-detail-registraion-tooth.component.html',
    styleUrls: [
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-registraion-tooth.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
    ],
})


export class ModalClientDetailRegistraionToothComponent implements OnInit, OnDestroy {
    en: any = {}
    showEN = true
    option_RegistrationTooth: String = 'active'
    TabRegistrationToothClass: any
    arrRegistrationTooth: any[] = []
    status: Boolean = false
    statusImage: String = ''
    url: String = ''
    tabName: any = 'tooth-all'
    arrTabRegistrationTooth = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: 'Right', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: 'Front', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: 'Left', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: 'Upper', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: 'Overjet', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: 'Lower', nameSave: 'Registration-Tooth-Lower' },
    ]
    option_Registration: String = 'active'
    senMax: any = 100
    max: any = 0
    arrAllTooth: any[] = []
    jsonTooth: any = {}
    index: any
    arrShowStatus: any[] = []
    uploadImageForm: FormGroup
    arrCopy: any[] = []
    showPaste: Boolean = false
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any
    valChange: any = 0
    arrLoading: any[] = []
    matrixImage: any[] = []
    arrImage: any[] = []
    arrImageHash
    emitTabName: any = {}

    emitArrAll: any = {}
    animationDuration: any

    arrStyle: any[] = [{}, {}, {}, {}, {}, {}]
    isEmptyArray: Boolean = false
    resourceUrl = 'resource'

    countRecrond
    tabUploadImage: any
    ValueAssignOneDistance: any = 0
    @ViewChild('imageWrapper') imageWrapper: ElementRef
    @ViewChild('imageId') imageId: ElementRef
    oldHeight: any
    oldWidth: any

    defaultArrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrIds: any[] = []

    unscrCopy
    unscrIndex
    unscrAllArrClientTop
    unscrArrHash

    getInfoIndex = undefined
    page = 'registration'
    unscrPage
    arrSlideshowTooth
    arrStyleImage = []
    settingImageData = {}
    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices,
                private stateServices: StateServices) {
        this.option_RegistrationTooth = 'active'
        this.TabRegistrationToothClass = 'option_0'
        this.option_Registration = 'active'
        this.arrLoading = [true, true, true, true, true, true]
        // this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
        const infoTabName: any = this.clientTopServices.functReturnTabName()
        if (infoTabName != null && infoTabName['tabName'] != undefined) {
            this.tabName = infoTabName['tabName']
        } else {
            this.tabName = 'tooth-all'
        }
        const tmpStr: String = this.tabName

        if (tmpStr.includes('tooth')) {
            // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            this.getArrClientTop()
            // });
        }
        // });
        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
    }

    ngOnInit() {
        this.clientTopServices.resetListImageTemporary()
        this.uploadImageForm = this.formBuider.group({
            requests: new FormArray([
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
            ]),
        })

        if (window.orientation !== undefined) {
            let tmpW = window.innerWidth
            if (window.orientation === 0 || window.orientation === 180) {
                tmpW = window.screen.width
                this.width = (tmpW - 300) / this.getNumberLineInRow(tmpW)
                this.height = this.width * 2 / 3
            } else {
                tmpW = window.screen.height
                this.width = (tmpW - 300) / this.getNumberLineInRow(tmpW)
                this.height = this.width * 2 / 3
            }

        } else {
            if ($(window).innerWidth() != window.screen.width) {
                this.width = ($(window).innerWidth() - 300) / this.getNumberLineInRow($(window).innerWidth())
                this.height = 2 * this.width / 3
            } else if ($(window).innerHeight() != window.screen.height) {
                const tmpH = $(window).innerHeight()
                this.height = (tmpH - 300) / this.getNumberLineInRow($(window).innerWidth(), false)
                this.width = this.height * 3 / 2
            }
        }


        this.oldHeight = this.height
        this.oldWidth = this.width
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        this.getArrHash()
        this.getStyle()
        this.resizeUser()
        this.resizeFullScreen()
        this.getPage()
        this.getSettingData()
    }

    getNumberLineInRow(width, isWidth = true) {
        if (width < 900) {
            return isWidth ? 1 : 6
        }
        if (width >= 900 && width <= 1300) {
            return isWidth ? 2 : 3
        }
        return isWidth ? 3 : 2
    }

    ngOnDestroy() {
        // this.unscrCopy.unsubscribe();
        this.getInfoIndex = undefined
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
        if(this.unscrArrHash)
            this.unscrArrHash.unsubscribe()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 200) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 200) / 2
                        this.width = this.height * 3 / 2
                    }
                }
                const _thi = this
                setTimeout(function() {
                    _thi.arrShowStatus.forEach((el, item) => {
                        if (el) {
                            const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                            const imageId: HTMLElement = document.getElementById('imageId' + item)
                            _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationTooth)
                        }
                    })
                }, 10)
            }
        })
    }

    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrStyleImage = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            const tmpStr: String = this.tabName
            if (tmpStr.includes('tooth')) {
                if (status != null && status['status'] != undefined) {
                    this.resetMatrix()
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        } else {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        }
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 300) / 2
                            this.width = this.height * 3 / 2
                        }
                    }
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                    const _thi = this
                    setTimeout(function() {
                        _thi.arrShowStatus.forEach((el, item) => {
                            if (el) {
                                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                                const imageId: HTMLElement = document.getElementById('imageId' + item)
                                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationTooth)
                            }
                        })
                    }, 10)
                }
            }
        })
    }

    getArrClientTop() {
        this.getDataShow()
        this.getDataIndex()
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            const tmpStr: String = this.tabName
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'registration') {
                this.index = infoIndex['index']
                this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                if (tmpStr.includes('tooth') && this.arrAllTooth.length > 0) {
                    this.max = this.arrAllTooth.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.index * this.ValueAssignOneDistance
                    } else {
                        this.valChange = 0
                    }
                    this.arrLoading = [false, false, false, false, false, false]
                    if (this.arrAllTooth[this.index] != undefined) {
                        this.jsonTooth = this.arrAllTooth[this.index]
                        this.initJsonTooth(this.arrAllTooth[this.index])
                        this.animationDuration = 300
                    }
                }
            } else {
                this.countRecrond = 0
                this.valChange = 0
            }
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            const tmpStr: String = this.tabName
            if (res != null && res['registration'] != undefined && res['registration'].length > 0 && this.page == 'registration') {
                this.isEmptyArray = false
                this.arrAllTooth = res['registration']
                this.countRecrond = res['registration'].length
                if (tmpStr.includes('tooth')) {
                    if (this.arrAllTooth.length > 0 && this.getInfoIndex) {
                        this.max = this.arrAllTooth.length - 1
                        if (this.max > 0) {
                            this.ValueAssignOneDistance = this.senMax / this.max
                            this.valChange = this.index * this.ValueAssignOneDistance
                        } else {
                            this.valChange = 0
                        }
                        if (this.arrAllTooth[this.index] != undefined) {
                            this.jsonTooth = this.arrAllTooth[this.index]
                            this.initJsonTooth(this.arrAllTooth[this.index])
                            this.animationDuration = 300
                        }
                    }
                }
            } else {
                this.countRecrond = 0
                this.valChange = 0
                this.isEmptyArray = true
                this.arrRegistrationTooth = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrRegistrationTooth)
            }
        })
    }

    getArrCopy() {
        this.unscrCopy = this.clientTopServices.changeEmittedArrCopy$.subscribe(arCopy => {
            if (arCopy != null && arCopy['onCut'] != undefined) {
                if (arCopy['onCut'] == 'cut') {
                    const tab = arCopy['tabName']
                    if (this.tabName == tab) {
                        this.arrRegistrationTooth = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationTooth)
                        this.jsonTooth[this.tabName] = this.arrRegistrationTooth
                        this.arrAllTooth[this.index] = this.jsonTooth
                        const arrCopy: any[] = arCopy['arrCopy']
                        const tmp: any = arrCopy[0]['id'] ? arrCopy[0]['id'] : ''
                        const jsonTmp: any = {}
                        jsonTmp['id'] = tmp
                        if (arrCopy[0]['id'] != '') {
                            switch (this.tabName) {
                                case 'tooth-right':
                                    if (tmp != '') {
                                        this.jsonTooth['tooth-all'][0] = jsonTmp
                                    }
                                    break
                                case 'tooth-front':
                                    if (tmp != '') {
                                        this.jsonTooth['tooth-all'][1] = jsonTmp
                                    }
                                    break
                                case 'tooth-left':
                                    if (tmp != '') {
                                        this.jsonTooth['tooth-all'][2] = jsonTmp
                                    }
                                    break
                                case 'tooth-upper':
                                    if (tmp != '') {
                                        this.jsonTooth['tooth-all'][3] = jsonTmp
                                    }
                                    break
                                case 'tooth-overjet':
                                    if (tmp != '') {
                                        this.jsonTooth['tooth-all'][4] = jsonTmp
                                    }
                                    break
                                case 'tooth-lower':
                                    if (tmp != '') {
                                        this.jsonTooth['tooth-all'][5] = jsonTmp
                                    }
                                    break
                                case 'tooth-all':
                                    arrCopy.forEach((el, i) => {
                                        switch (i) {
                                            case 0:
                                                this.jsonTooth['tooth-right'][0] = jsonTmp
                                                break
                                            case 1:
                                                this.jsonTooth['tooth-front'][0] = jsonTmp
                                                break
                                            case 2:
                                                this.jsonTooth['tooth-left'][0] = jsonTmp
                                                break
                                            case 3:
                                                this.jsonTooth['tooth-upper'][0] = jsonTmp
                                                break
                                            case 4:
                                                this.jsonTooth['tooth-overjet'][0] = jsonTmp
                                                break
                                            case 5:
                                                this.jsonTooth['tooth-lower'][0] = jsonTmp
                                                break
                                            default:
                                                break
                                        }
                                    })
                                    break
                                default:
                                    break
                            }
                            this.emitArrAll['registration'] = this.arrAllTooth
                            this.emitArrAll['checkChange'] = true
                            this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                        }
                    }
                }
            }
        })
    }

    getStyle() {
        this.clientTopServices.changeEmittedStyle$.subscribe(style => {
            if (style != null && style['style'] != undefined) {
                const tab: any = style['tabName']
                if (tab == this.tabName) {
                    this.arrStyle = style['style']
                    if (this.arrStyle.length > 0) {
                        this.arrRegistrationTooth = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationTooth)
                        this.jsonTooth[this.tabName] = this.arrRegistrationTooth
                        this.arrAllTooth[this.index] = this.jsonTooth
                        this.emitArrAll['registration'] = this.arrAllTooth
                        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                    } else {
                        const arrCopy: any[] = style['arrCopy']
                        this.arrRegistrationTooth = arrCopy
                        this.getShowStatus(this.arrRegistrationTooth)
                        this.jsonTooth[this.tabName] = this.arrRegistrationTooth
                        this.arrAllTooth[this.index] = this.jsonTooth
                    }
                }
            } else {
                this.arrStyle = [{}, {}, {}, {}, {}, {}]
            }
        })
    }

    getArrHash() {
        this.unscrArrHash = this.stateServices.changeEmittedHash$.subscribe(response => {
            if (response != null && response[this.tabName] != undefined && response[this.tabName].length > 0) {
                const tmpStr: String = this.tabName
                const arrRes: any[] = response[this.tabName]
                if (tmpStr.includes('tooth')) {
                    this.arrRegistrationTooth = jQuery.extend(true, [], arrRes)
                    // arrRes.forEach((el, i) => {
                    //     this.arrRegistrationTooth[i] = el;
                    // });
                    this.jsonTooth[this.tabName] = jQuery.extend(true, [], this.arrRegistrationTooth)
                    this.arrAllTooth[this.index] = jQuery.extend(true, {}, this.jsonTooth)
                    const tmp: any = arrRes[0]
                    switch (this.tabName) {
                        case 'tooth-right':
                            this.arrAllTooth[this.index]['tooth-all'][0] = tmp
                            break
                        case 'tooth-front':
                            this.arrAllTooth[this.index]['tooth-all'][1] = tmp
                            break
                        case 'tooth-left':
                            this.arrAllTooth[this.index]['tooth-all'][2] = tmp
                            break
                        case 'tooth-upper':
                            this.arrAllTooth[this.index]['tooth-all'][3] = tmp
                            break
                        case 'tooth-overjet':
                            this.arrAllTooth[this.index]['tooth-all'][4] = tmp
                            break
                        case 'tooth-lower':
                            this.arrAllTooth[this.index]['tooth-all'][5] = tmp
                            break
                        case 'tooth-all':
                            this.arrAllTooth[this.index]['tooth-right'][0] = arrRes[0]
                            this.arrAllTooth[this.index]['tooth-front'][0] = arrRes[1]
                            this.arrAllTooth[this.index]['tooth-left'][0] = arrRes[2]
                            this.arrAllTooth[this.index]['tooth-upper'][0] = arrRes[3]
                            this.arrAllTooth[this.index]['tooth-overjet'][0] = arrRes[4]
                            this.arrAllTooth[this.index]['tooth-lower'][0] = arrRes[5]
                            break
                        default:
                            break
                    }
                    this.emitArrAll['registration'] = this.arrAllTooth
                    this.emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                }
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (window.orientation !== undefined) {
            let tmpW = window.innerWidth
            if (window.orientation === 0 || window.orientation === 180) {
                tmpW = window.screen.width
                this.width = (tmpW - 300) / this.getNumberLineInRow(tmpW)
                this.height = this.width * 2 / 3
            } else {
                tmpW = window.screen.height
                this.width = (tmpW - 300) / this.getNumberLineInRow(tmpW)
                this.height = this.width * 2 / 3
            }
        } else {
            if (event.target.innerWidth != window.screen.width) {
                const tmpW = event.target.innerWidth
                this.width = (tmpW - 300) / this.getNumberLineInRow(tmpW)
                this.height = this.width * 2 / 3
            } else if (event.target.innerHeight != window.screen.height) {
                const tmpH = event.target.innerHeight
                this.height = (tmpH - 300) / this.getNumberLineInRow(event.target.innerWidth, false)
                this.width = this.height * 3 / 2
            }
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * tmpEarch
            // if (this.arrAllTooth[this.index] != undefined) {
            //     this.jsonTooth = this.arrAllTooth[this.index];
            //     this.initJsonTooth(this.jsonTooth);
            //     this.arrRegistrationTooth = this.jsonTooth[this.tabName];
            // }
            // this.valChange = assign;
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.valChange = 0
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(0)
        }
    }

    initJsonTooth(json: any = {}) {
        this.jsonTooth['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonTooth['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonTooth['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonTooth['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonTooth['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonTooth['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonTooth['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.getArrRegistrationTooth(this.jsonTooth)
    }

    getArrRegistrationTooth(arrTooth) {
        this.arrRegistrationTooth = arrTooth[this.tabName]
        this.getShowStatus(this.arrRegistrationTooth)
    }

    onDeleteImage(index) {
        this.matrixServices.removePhoto(index)
        const tmpNone: any = {}
        tmpNone['id'] = ''
        this.arrRegistrationTooth[index] = tmpNone
        switch (this.TabRegistrationToothClass) {
            case 'option_0':
                this.jsonTooth['tooth-all'] = this.arrRegistrationTooth
                let i: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'tooth-right'
                        break
                    case 2:
                        i = 'tooth-front'
                        break
                    case 3:
                        i = 'tooth-left'
                        break
                    case 4:
                        i = 'tooth-upper'
                        break
                    case 5:
                        i = 'tooth-overjet'
                        break
                    case 6:
                        i = 'tooth-lower'
                        break
                    default:
                        break
                }
                const tmp: any = {}
                tmp['id'] = ''
                this.jsonTooth[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonTooth['tooth-all'][0] = tmp1
                }
                this.jsonTooth['tooth-right'] = this.arrRegistrationTooth
                break
            case 'option_2':
                if (index == 0) {
                    const tmp2: any = {}
                    tmp2['id'] = ''
                    this.jsonTooth['tooth-all'][1] = tmp2
                }
                this.jsonTooth['tooth-front'] = this.arrRegistrationTooth
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][2] = tmp3
                }
                this.jsonTooth['tooth-left'] = this.arrRegistrationTooth
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][3] = tmp3
                }
                this.jsonTooth['tooth-upper'] = this.arrRegistrationTooth
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][4] = tmp3
                }
                this.jsonTooth['tooth-overjet'] = this.arrRegistrationTooth
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][5] = tmp3
                }
                this.jsonTooth['tooth-lower'] = this.arrRegistrationTooth
                break
            default:
                break
        }
        this.uploadImageForm.reset()
        // this.matrixServices.removePhoto(index);
        this.arrAllTooth[this.index] = this.jsonTooth
        this.emitArrAll['registration'] = this.arrAllTooth
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationTooth)
    }

    swapMatrix(index, nextIndex) {
        const tmp = this.matrixImage[index]
        const swapTmp = this.matrixImage[nextIndex]
        this.matrixImage[index] = swapTmp
        this.matrixImage[nextIndex] = tmp
    }

    swapArrImage(index, nextIndex) {
        const tmp = this.arrImage[index]
        const swapTmp = this.arrImage[nextIndex]
        this.arrImage[index] = swapTmp
        this.arrImage[nextIndex] = tmp
    }

    swapArrImageStyle(index, nextIndex) {
        const tmp = this.arrStyleImage[index]
        const swapTmp = this.arrStyleImage[nextIndex]
        this.arrStyleImage[index] = swapTmp
        this.arrStyleImage[nextIndex] = tmp
    }

    swapArr(index, nextIndex) {
        this.swapMatrix(index, nextIndex)
        this.swapArrImage(index, nextIndex)
        this.swapArrImageStyle(index, nextIndex)
        const tmp = this.arrRegistrationTooth[index]
        const tmpRight = this.arrRegistrationTooth[nextIndex]
        this.arrRegistrationTooth[index] = tmpRight
        this.arrRegistrationTooth[nextIndex] = tmp
        switch (this.TabRegistrationToothClass) {
            case 'option_0':
                this.jsonTooth['tooth-all'] = this.arrRegistrationTooth
                let i: any
                let left: any
                let right: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'tooth-right'
                        right = 'tooth-front'
                        break
                    case 2:
                        left = 'tooth-right'
                        i = 'tooth-front'
                        right = 'tooth-left'
                        break
                    case 3:
                        left = 'tooth-front'
                        i = 'tooth-left'
                        right = 'tooth-upper'
                        break
                    case 4:
                        left = 'tooth-left'
                        i = 'tooth-upper'
                        right = 'tooth-overjet'
                        break
                    case 5:
                        left = 'tooth-upper'
                        i = 'tooth-overjet'
                        right = 'tooth-lower'
                        break
                    case 6:
                        left = 'tooth-overjet'
                        i = 'tooth-lower'
                        break
                }
                if (index > nextIndex) {
                    this.jsonTooth[left][0] = tmp
                    this.jsonTooth[i][0] = tmpRight
                } else {
                    this.jsonTooth[i][0] = tmpRight
                    this.jsonTooth[right][0] = tmp
                }
                break
            case 'option_1':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonTooth['tooth-all'][0] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][0] = tmp3
                }
                this.jsonTooth['tooth-right'] = this.arrRegistrationTooth
                break
            case 'option_2':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonTooth['tooth-all'][1] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][1] = tmp3
                }
                this.jsonTooth['tooth-front'] = this.arrRegistrationTooth
                break
            case 'option_3':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonTooth['tooth-all'][2] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][2] = tmp3
                }
                this.jsonTooth['tooth-left'] = this.arrRegistrationTooth
                break
            case 'option_4':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonTooth['tooth-all'][3] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][3] = tmp3
                }
                this.jsonTooth['tooth-upper'] = this.arrRegistrationTooth
                break
            case 'option_5':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonTooth['tooth-all'][4] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][4] = tmp3
                }
                this.jsonTooth['tooth-overjet'] = this.arrRegistrationTooth
                break
            case 'option_6':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonTooth['tooth-all'][5] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonTooth['tooth-all'][5] = tmp3
                }
                this.jsonTooth['tooth-lower'] = this.arrRegistrationTooth
                break
            default:
                break
        }
        this.arrAllTooth[this.index] = this.jsonTooth
        this.emitArrAll['registration'] = this.arrAllTooth
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationTooth)
    }

    moveRight(index) {
        const nextIndex: any = index + 1
        this.swapArr(index, nextIndex)
    }

    moveLeft(index) {
        const nextIndex: any = index - 1
        this.swapArr(index, nextIndex)
    }

    resetMatrixMovedUpPage() {
        const _thi = this
        setTimeout(function() {
            _thi.arrShowStatus.forEach((el, item) => {
                if (el) {
                    const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                    const imageId: HTMLElement = document.getElementById('imageId' + item)
                    if (imageId != undefined && imageWrapper != undefined) {
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationTooth)
                    }
                }
            })
        }, 10)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.matrixImage = []
        this.arrImage = []
        this.arrStyleImage = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    let url
                    if (this.arrayTypeImage[i] != 'other') {
                        url = getImageRedirectUrl(el['id'] + '?type=' + this.arrayTypeImage[i])
                    } else {
                        url = getImageRedirectUrl(el['id'])
                    }
                    this.arrIds[i] = el['id']
                    this.arrImage.push(url)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
                if (el != undefined && el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
                if (el != undefined && el['style'] != undefined) {
                    this.arrStyleImage.push(el['style'])
                } else {
                    this.arrStyleImage.push({})
                }
            })
            this.getStyleMatrix(this.matrixImage, this.arrImage, this.arrRegistrationTooth)
        }
    }

    getStyleMatrix(matrixImage, arrImage, arrRegistrationTooth) {
        const _thi = this
        setTimeout(() => {
            _thi.arrRegistrationTooth.forEach(function(el, item) {
                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                const imageId: HTMLElement = document.getElementById('imageId' + item)
                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, matrixImage, arrImage, arrRegistrationTooth)
            })
        }, 200)
    }

    toggleTabRegistrationToothItem(id, index, event) {
        this.uploadImageForm.reset()
        this.clientTopServices.emitChangeCount(1)
        this.TabRegistrationToothClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'tooth-all'
                break
            case 'option_1':
                this.tabName = 'tooth-right'
                break
            case 'option_2':
                this.tabName = 'tooth-front'
                break
            case 'option_3':
                this.tabName = 'tooth-left'
                break
            case 'option_4':
                this.tabName = 'tooth-upper'
                break
            case 'option_5':
                this.tabName = 'tooth-overjet'
                break
            case 'option_6':
                this.tabName = 'tooth-lower'
                break
            default:
                this.tabName = 'tooth-all'
                break
        }
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.tabUploadImage = undefined
        this.emitTabName['tabName'] = this.tabName
        this.arrRegistrationTooth = this.jsonTooth[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrRegistrationTooth)
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined != this.arrRegistrationTooth && this.arrRegistrationTooth.length > 0) {
                const tmp: any = this.arrRegistrationTooth[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    setArrClientTop(data, index, idImage) {
        switch (this.tabUploadImage) {
            case 'option_0':
                this.jsonTooth['tooth-all'] = data
                // this.arrRegistrationTooth = data;
                let i: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'tooth-right'
                        break
                    case 2:
                        i = 'tooth-front'
                        break
                    case 3:
                        i = 'tooth-left'
                        break
                    case 4:
                        i = 'tooth-upper'
                        break
                    case 5:
                        i = 'tooth-overjet'
                        break
                    case 6:
                        i = 'tooth-lower'
                        break
                }
                const tmp: any = idImage
                this.jsonTooth[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonTooth['tooth-all'][0] = tmp3
                }
                this.jsonTooth['tooth-right'] = data
                break
            case 'option_2':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonTooth['tooth-all'][1] = tmp3
                }
                this.jsonTooth['tooth-front'] = data
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonTooth['tooth-all'][2] = tmp3
                }
                this.jsonTooth['tooth-left'] = data
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonTooth['tooth-all'][3] = tmp3
                }
                this.jsonTooth['tooth-upper'] = data
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonTooth['tooth-all'][4] = tmp3
                }
                this.jsonTooth['tooth-overjet'] = data
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = idImage
                    this.jsonTooth['tooth-all'][5] = tmp3
                }
                // this.arrRegistrationTooth = data;
                this.jsonTooth['tooth-lower'] = data
                break
            default:
                break
        }
        this.arrAllTooth[this.index] = this.jsonTooth
        this.emitArrAll['registration'] = this.arrAllTooth
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
    }

    uploadFileEnd(event) {
        this.tabUploadImage = this.TabRegistrationToothClass
        this.clientTopServices.checkChangeData = true
        const jsonFlip: any = {
            'horizontalFlip': 1,
            'verticalFlip': 1,
        }
        const i = event.item
        this.matrixServices.arrFlip[i] = jsonFlip
        const tmp: any = {}
        tmp['id'] = event.success['hash']
        tmp['matrix'] = [1, 0, 0, 1]
        this.arrRegistrationTooth[i] = tmp
        this.clientTopServices.emitUploadImageIndex(i)
        this.matrixImage[i] = [1, 0, 0, 1]
        const url = getImageRedirectUrl(event.success['hash'])
        this.arrImage[i] = url
        this.getShowStatus(this.arrRegistrationTooth)
        this.setArrClientTop(this.arrRegistrationTooth, i, this.arrRegistrationTooth[i])
        this.arrLoading[i] = false
    }

    onStartUpload(event) {
        let listUpload: any[] = event.listUpload
        this.animationDuration = event.animationDuration
        const arrLenghtImageFile = event.arrLenghtImageFile
        for (let index = 0; index < listUpload.length; index++) {
            if (listUpload[index] && arrLenghtImageFile > index) {
                this.arrLoading[listUpload[index]] = true
            }
        }
    }

    onUploadError() {
        this.uploadImageForm.reset()
    }

    handleFileInput(files: FileList, ind, event) {
        if (event.target.files && event.target.files[0]) {
            this.tabUploadImage = this.TabRegistrationToothClass
            const arrUploadImage: any[] = this.arrRegistrationTooth
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            const excrptFile: any = 'image/'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                this.animationDuration = 2800
                this.arrLoading[ind] = true
                reader.onload = (event: any) => {
                    this.getUrlImage(this.index, event.target.result)
                    this.url = event.target.result
                    this.arrShowStatus[ind] = true;
                }
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            this.clientTopServices.emitUploadImageIndex(ind);
                            const jsonFlip: any = {
                                'horizontalFlip': 1,
                                'verticalFlip': 1,
                            }
                            this.arrLoading[ind] = false
                            this.matrixServices.arrFlip[ind] = jsonFlip
                            const tmp: any = {}
                            tmp['id'] = success['hash']
                            tmp['matrix'] = [1, 0, 0, 1]
                            Object.assign(this.arrRegistrationTooth[ind], tmp)
                            this.getShowStatus(this.arrRegistrationTooth)
                            this.setArrClientTop(arrUploadImage, ind, arrUploadImage[ind])
                            this.clientTopServices.emitChangeCount(0)
                            this.resetFile(ind)
                        },
                    )
                })
            } else {
                this.uploadImageForm.reset()
            }
        } else {
            this.uploadImageForm.reset()
        }
    }

    resetFile(item) {
        $('#fileUpload_' + item).val('');
    }
    
    isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    getSettingData() {
        this.clientTopServices.settingEmitData$.subscribe(data => {
            if (data && data.length > 0) {
                const settingToothImageData = data.find(el => {
                    return el['_id'] == 'settingImage';
                });
                if(settingToothImageData && !this.isEmpty(settingToothImageData)) {
                   this.settingImageData = settingToothImageData
                }
            } 
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/registrationTooth/modal-client-detail-registraion-tooth.component.ts